import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { from, of, switchMap } from 'rxjs';
import { getFullPath } from '../../lib/get-full-path';
import { AffiliateService } from '../../services/affiliate.service';

export const storyblokAffiliateRedirectGuard: CanActivateFn = route => {
  const affiliateService = inject(AffiliateService);
  const path = getFullPath(route);
  const first = path[0];
  if (path.length > 1 || !first || first.includes('.')) return of(undefined);
  return from(affiliateService.getAffiliate(first)).pipe(
    switchMap(affiliate => {
      if (!affiliate) return of(undefined);
      return from(affiliateService.affiliateRedirect(affiliate));
    })
  );
};
